/**
 * Custom Hero JavaScript - Interactive Effects
 */

(function() {
  'use strict';

  let scrollY = 0;
  let mousePos = { x: 0, y: 0 };

  // Initialize when DOM is ready
  function init() {
    setupScrollEffects();
    setupMouseFollower();
    setupParallax();
    setupSocialSidebar();
    setupRisingCurtainEffect();
  }

  // Scroll Effects - Change header style on scroll
  function setupScrollEffects() {
    const header = document.querySelector('[data-scroll-header]');
    if (!header) return;

    window.addEventListener('scroll', function() {
      scrollY = window.scrollY;

      if (scrollY > 50) {
        header.classList.add('scrolled');
      } else {
        header.classList.remove('scrolled');
      }
    });
  }

  // Mouse Follower Effect
  function setupMouseFollower() {
    const follower = document.querySelector('.mouse-follower');
    if (!follower) return;

    // Only enable on desktop
    if (window.innerWidth < 1024) return;

    document.addEventListener('mousemove', function(e) {
      mousePos.x = e.clientX;
      mousePos.y = e.clientY;

      // Update follower position with smooth transition
      requestAnimationFrame(function() {
        follower.style.left = (mousePos.x - 40) + 'px';
        follower.style.top = (mousePos.y - 40) + 'px';
      });
    });
  }

  // Parallax Effect on Hero Text
  function setupParallax() {
    const parallaxText = document.querySelector('[data-parallax-text]');
    if (!parallaxText) return;

    window.addEventListener('scroll', function() {
      const scrolled = window.scrollY;

      requestAnimationFrame(function() {
        // Parallax movement (removed blur effect for clarity)
        const translateY = scrolled * 0.1;
        const scale = 1 + scrolled * 0.0001;

        parallaxText.style.transform = `translateY(${translateY}px) scale(${scale})`;
      });
    });
  }

  // Hide/Show Social Sidebar on scroll
  function setupSocialSidebar() {
    const sidebar = document.querySelector('[data-social-sidebar]');
    if (!sidebar) return;

    window.addEventListener('scroll', function() {
      const scrolled = window.scrollY;

      if (scrolled > 50) {
        sidebar.classList.add('hidden');
      } else {
        sidebar.classList.remove('hidden');
      }
    });
  }

  // Rising Curtain Effect - Content rises up over hero
  function setupRisingCurtainEffect() {
    const heroWrapper = document.querySelector('.custom-hero-wrapper');
    if (!heroWrapper) return;

    let ticking = false;

    window.addEventListener('scroll', function() {
      if (!ticking) {
        window.requestAnimationFrame(function() {
          const scrolled = window.scrollY;

          // Hero scrolls at 50% speed - creates illusion of content rising faster
          const parallaxOffset = scrolled * 0.5;
          heroWrapper.style.transform = `translateY(${parallaxOffset}px)`;

          ticking = false;
        });

        ticking = true;
      }
    });
  }

  // Smooth scroll for anchor links
  function setupSmoothScroll() {
    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
      anchor.addEventListener('click', function (e) {
        const href = this.getAttribute('href');
        if (href === '#') return;

        e.preventDefault();
        const target = document.querySelector(href);

        if (target) {
          const offsetTop = target.offsetTop - 100;
          window.scrollTo({
            top: offsetTop,
            behavior: 'smooth'
          });
        }
      });
    });
  }

  // Initialize on DOMContentLoaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-initialize on window resize (for responsive adjustments)
  let resizeTimeout;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(function() {
      // Re-setup mouse follower if needed
      setupMouseFollower();
    }, 250);
  });

  // Discount Modal Functionality
  function setupDiscountModal() {
    const trigger = document.querySelector('[data-discount-trigger]');
    const modal = document.querySelector('[data-discount-modal]');
    const closeButtons = modal?.querySelectorAll('[data-modal-close]');
    const form = document.querySelector('[data-discount-form]');
    const submitText = document.querySelector('[data-submit-text]');
    const submitLoading = document.querySelector('[data-submit-loading]');

    if (!trigger || !modal) return;

    // Open modal
    function openModal() {
      modal.classList.add('active');
      document.body.style.overflow = 'hidden';
    }

    // Close modal
    function closeModal() {
      modal.classList.remove('active');
      document.body.style.overflow = '';
    }

    // Trigger click
    trigger.addEventListener('click', openModal);

    // Keyboard support for trigger
    trigger.addEventListener('keydown', function(e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        openModal();
      }
    });

    // Close buttons
    closeButtons?.forEach(btn => {
      btn.addEventListener('click', closeModal);
    });

    // Escape key
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && modal.classList.contains('active')) {
        closeModal();
      }
    });

    // Form submission
    if (form) {
      form.addEventListener('submit', async function(e) {
        e.preventDefault();

        const email = form.querySelector('input[type="email"]').value;

        // Show loading state
        if (submitText && submitLoading) {
          submitText.style.display = 'none';
          submitLoading.style.display = 'block';
        }

        try {
          // Subscribe to Shopify email marketing
          const response = await fetch('/contact', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded',
            },
            body: new URLSearchParams({
              'form_type': 'customer',
              'utf8': '✓',
              'contact[email]': email,
              'contact[tags]': 'newsletter,discount-5-percent'
            })
          });

          // Success
          setTimeout(() => {
            modal.querySelector('.discount-modal-inner').innerHTML = `
              <div style="padding: 2rem 0;">
                <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="#7B5454" stroke-width="2" style="margin: 0 auto 1rem; display: block;">
                  <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
                  <polyline points="22 4 12 14.01 9 11.01"></polyline>
                </svg>
                <h2 style="font-size: 1.5rem; font-weight: 600; color: #7B5454; margin-bottom: 1rem;">Thank You!</h2>
                <p style="font-size: 1rem; color: rgba(0, 0, 0, 0.7); margin-bottom: 1.5rem;">Check your email for your exclusive 5% discount code!</p>
                <button onclick="document.querySelector('[data-discount-modal]').classList.remove('active'); document.body.style.overflow = '';" style="padding: 0.75rem 2rem; background: #7B5454; color: white; border: none; border-radius: 12px; cursor: pointer; font-weight: 600;">Continue Shopping</button>
              </div>
            `;
          }, 1000);

        } catch (error) {
          console.error('Error submitting form:', error);

          // Reset button state
          if (submitText && submitLoading) {
            submitText.style.display = 'block';
            submitLoading.style.display = 'none';
          }
        }
      });
    }
  }

  // Initialize discount modal
  setupDiscountModal();

})();
